import React from "react"
import RevisionItemTable from "./RevisionItemTable"
import { Item } from "../../libs/api/backend/src"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { cn } from "@malond/ui/utils"

interface RevisionGridColProps {
  prefixTitle: string
  items: Item[]
  countAllItems: number
  onClickCol: (item: Item) => void
  limit: number
  offset: number
  onClickPrev: () => void
  onClickNext: () => void
}

export default function RevisionGridCol({
  prefixTitle,
  items,
  countAllItems,
  onClickCol,
  limit,
  offset,
  onClickPrev,
  onClickNext,
}: RevisionGridColProps) {
  return (
    <React.Fragment>
      <div className="relative print:hidden">
        <p className="mb-2 font-medium text-foreground">
          {prefixTitle}: {countAllItems}
        </p>

        <RevisionItemTable
          onClickCol={(item) => onClickCol(item)}
          items={items || []}
          limit={limit}
          offset={offset}
        />

        <div className="mt-4 grid justify-center text-center align-middle">
          <span className="isolate inline-flex rounded-md shadow-xs">
            <button
              type="button"
              className="relative inline-flex items-center gap-1 rounded-l-md border border-border bg-card px-2.5 py-1.5 text-muted-foreground transition-colors hover:bg-muted focus:z-10 disabled:cursor-not-allowed disabled:opacity-50"
              disabled={offset === 0}
              onClick={() => onClickPrev()}
            >
              <ChevronLeft className="size-4" aria-hidden="true" />
              <span className="text-xs font-semibold text-foreground">
                Назад
              </span>
            </button>

            <span className="relative -ml-px inline-flex items-center border border-border bg-card px-3 py-1.5 text-xs text-muted-foreground">
              с {offset + 1} по {Math.min(items?.length || 0, offset + limit)}{" "}
              из {items?.length || 0}
            </span>

            <button
              type="button"
              className="relative -ml-px inline-flex items-center gap-1 rounded-r-md border border-border bg-card px-2.5 py-1.5 text-muted-foreground transition-colors hover:bg-muted focus:z-10 disabled:cursor-not-allowed disabled:opacity-50"
              disabled={offset + limit >= (items?.length || 0)}
              onClick={() => onClickNext()}
            >
              <span className="text-xs font-semibold text-foreground">
                Вперёд
              </span>
              <ChevronRight className="size-4" aria-hidden="true" />
            </button>
          </span>
        </div>
      </div>
    </React.Fragment>
  )
}
